import DatePickerContainer from "../../../../../Components/Forms&Table/Forms/FormWidgets/DatePicker/DatePickerContainer";

const DatePicker = () => {
  return <DatePickerContainer />;
};

export default DatePicker;
